import { makeAutoObservable } from 'mobx';

import type { RootStore } from 'store/RootStore';
import { LoadType } from 'types/cargosApp/Load';

export class LoadsSync {
  readonly #root: RootStore;

  constructor(root: RootStore) {
    this.#root = root;

    makeAutoObservable(this);
  }

  syncLoadState = (sourceLoads: LoadType[], prevLoad: LoadType, updatedLoad: LoadType) => {
    const isFavoriteChanged =
      updatedLoad.isFavorite !== undefined && Boolean(prevLoad.isFavorite) !== Boolean(updatedLoad.isFavorite);
    const isCounterOfferChanged = prevLoad.request?.counterOffer !== updatedLoad.request?.counterOffer;
    if (!isFavoriteChanged && !isCounterOfferChanged) return;

    const { favorites, loadsWithOffers, loadsWithAuctions } = this.#root.followedLoads;
    const lists = [
      this.#root.app.searchResult?.loads,
      favorites.favoriteLoads,
      loadsWithOffers.loadsWithOffers,
      loadsWithAuctions.loadsWithAuctions,
    ];

    lists.forEach(loads => {
      if (!loads || loads === sourceLoads) return;

      const index = loads.findIndex(load => load.id == updatedLoad.id);
      if (index === -1) return;

      const load = loads[index];
      const patch: Partial<LoadType> = {};
      if (isFavoriteChanged) patch.isFavorite = updatedLoad.isFavorite;
      if (isCounterOfferChanged) patch.request = { ...load.request, counterOffer: updatedLoad.request?.counterOffer };
      loads[index] = { ...load, ...patch };
    });
  };
}
